import axios from 'axios';
import msgpack from 'msgpack-lite';
export default class PageSource {
  /**
   * Fetch all the other data from server
   * @return {Promise}
   */
  static fetch() {
    // return this.fetchMsgpack();
    // If you want to go back to JSON API :
    return axios.get('/api/pages.json').then(response => {
      return Promise.resolve(response.data);
    });
  }

  /**
   * Fetch all the other data from server
   * @return {Promise}
   */
  static fetchMsgpack() {
    return axios
      .get('/api/pages.msgpack', {
        responseType: 'blob',
        headers: {'Content-Type': 'application/msgpack; charset=utf-8'},
      })
      .then(response => {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = function(e) {
            const pack = msgpack.decode(new Uint8Array(reader.result));
            resolve(pack);
          };
          reader.readAsArrayBuffer(response.data);
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/sources/PageSource.js